<template>
    <div class="generic_popups">
        <b-modal size="lg" header-class="header_style" :title="errorTitle" id="error-modal" :ok-title="errorOkText" ok-only
                 v-model="showError">
            <h5><span v-html="errorText"></span></h5>
        </b-modal>
        <b-modal size="lg" header-class="header_style" :title="dialogTitle" id="dialog-modal" :ok-title="dialogOkText" :cancel-title="dialogCancelText"
                 v-model="showDialog"
                 @ok="dialogOkFunction">
            <h5><span v-html="dialogText"></span></h5>
        </b-modal>
        <b-modal size="lg" header-class="header_style" :title="permissionTitle" id="dialog-modal"
                 @hidden="cancelPermission"
                 v-model="showPermission">
            <h5><span v-html="permissionText"></span></h5>
            <LoadingSpinner :busy="isLoadingPermission"></LoadingSpinner>
            <div v-if="!canPermissionAccept">
                <hr v-if="permissionError">
                <div class="text-danger text-center">{{permissionError}}</div>
                <hr>
                <div class="text-center" style="line-height:15px;">To override this restriction, please enter a supervisor password below:
                    <div class="row mt-2">
                        <b-input name="authentication_2" autocomplete="off" class="offset-4 col-4" v-model="password" type="password"></b-input>
                    </div>
                    <div class="row mt-2">
                        <div class="offset-2 mt-2">...or request override from:</div>
                        <div class="col-4"><b-form-select size="sm" v-model="selected_user" :options="users"> </b-form-select></div>
                    </div>
                    <div class="row mt-2" v-if="selected_user">
                        <b-form-textarea v-model="description"
                             rows="3"
                             max-rows="6"
                             placeholder ="(provide reason/information)"
                             class="offset-2 col-8 mt-1"
                        >
                        </b-form-textarea>
                    </div>

                </div>
            </div>
            <template #modal-footer>
                <b-row>
                    <b-col class="mr-2" cols="*">
                        <b-button block @click="cancelPermission">{{permissionCancelText}}</b-button>
                    </b-col>
                    <b-col class="mr-2" cols="*">
                        <b-button block @click="checkPermission" variant="primary" :disabled="isLoadingPermission || isPermissionWorking || is_waiting">
                            <i class="mr-2 fa-regular fa-spin fa-spinner" v-if="is_waiting"></i>
                            <span v-if="request_sent">Your request has been sent</span>
                            <span v-else>{{permissionOkText}}</span>

                        </b-button>
                    </b-col>
                </b-row>
            </template>
        </b-modal>
        <b-modal size="lg" header-class="header_style"
                 :title="requestor.name + ' had the following message \'' + requestorMessage + '\' and is requesting permission to override the permission ' + requestorPermission"
                 id="dialog-modal" :ok-title="'Ok'" :cancel-title="'Cancel'"
                 v-model="permissionRequestShow"
                 @ok="approvePermission">
            <h5><span v-html="dialogText"></span></h5>
        </b-modal>

    </div>
</template>
<!-- FIXME  this is basically what the response needs to diplay in the end.
Tracy Williams had the following message Not allowed to update Customers 'dob' field.' and is requesting permission to override the permission Customers.dob.write.
Customer: 9000224
Order: 583781
Page: link
Notes: test
-->

<script>
    import {
        BROADCAST_CONNECTED,
    } from '@/store/actions';
    import LoadingSpinner from './LoadingSpinner';
    import {SYNC_USER, OVERRIDE} from '../store/actions';
    export default {
        name: 'GenericPopups',
        components: {LoadingSpinner},
        data() {
            return {
                //base error, only ok
                showError: false,
                errorTitle: '',
                errorText: '',
                errorOkText: '',
                errorClose: function(){},

                //dialog, accept or decline
                showDialog: false,
                dialogTitle: '',
                dialogText: '',
                dialogOkText: '',
                dialogCancelText: '',
                dialogOkFunction: function () {},
                dialogClose: function(){},

                //full permission interface
                showPermission: false,
                permissionTitle: '',
                permissionText: '',
                permissionOkText: '',
                permissionCancelText: '',
                permission: '',
                permissionError: null,
                isLoadingPermission: false,
                userHasPermission: false,
                selected_user: null,
                users: [],
                password: '',
                description: '',
                isPermissionWorking: false,
                permission_order_id: null,
                permission_customer_id: null,
                permissionOkFunction: function () {},
                permissionClose: function(){},
                is_waiting: false,
                permissionTimeout: null,
                PERMDEBUG: {},

                //permission acceptance interface
                permissionRequestShow: false,
                requestor: '',
                requestorMessage: '',
                requestorPermission: '',
                requestorPage: '',
                requestor_order_id: '',
                requestor_customer_id: '',
                request_sent: false,

                permissionEndpointWrap: [],
            };
        },
        created() {

        },
        mounted() {
            console.info(String.fromCodePoint(0x1F6F0) + '%c Broadcast Connected:', 'color:yellow;', this.$store.getters.isBroadcastConnected);
            if (! this.$store.getters.isBroadcastConnected) {
                this.$store.subscribe((mutation) => {
                    if (mutation.type === BROADCAST_CONNECTED) {
                        console.log('%cSubscribe mutation ' + mutation.type, 'color:gray;');
                        console.info(String.fromCodePoint(0x1F504) + '%c Joining via BROADCAST_CONNECTED mutation.', 'color:green;');
                        this.joinBroadcastChannel();
                    }
                });
            } else {
                console.info(String.fromCodePoint(0x2757) + '%c Joining via isBroadcastConnected getter.', 'color:teal;');
                this.joinBroadcastChannel();
            }
        },
        beforeDestroy() {
            //this.$barcodeScanner.destroy();
        },
        methods: {
            //todo, two broadcast listners, one for user acceptance, one for user response (accept/decline).
            checkPermission() {
                if(this.userHasPermission) {
                    this.permissionOkFunction();
                    this.cancelPermission();
                }
                else {
                    this.approvePermission();
                }
            },
            joinBroadcastChannel: function () {
                this.$store.dispatch(SYNC_USER, (profile) => {
                    console.info(String.fromCodePoint(0x1F514) + ' Subscribing \'PermissionResponseEvent\' on App.User.' + profile.id + ' channel from GenericPopups.');
                    this.$echo.channel('App.User.' + profile.id)
                        .listen('PermissionResponseEvent', (perm) => {
                            this.permissionResponse(perm);
                        });
                });
            },
            approvePermission() {
                /*
                    public $id;
                    public $password;
                    public $description;
                    public $permissionMessage;
                    public $permissionName;
                    public $pageLink;
                    public $order_id;
                    public $customer_id;
                 */
                this.is_waiting = true;
                let payload = {
                    id: this.selected_user,
                    password: this.password,
                    description: this.description,
                    permissionMessage: this.permissionText,
                    permissionName: this.permission,
                    pageLink: this.$route.fullPath,
                    order_id: this.order_id,
                    customer_id: this.customer_id,
                };
                this.$http.post('/users/requestPermission', payload).then(response => {
                    this.request_sent = true;
                    this.is_waiting = false;
                    if (response.data.approved) {
                        this.permissionOkFunction();
                        this.cancelPermission();
                        this.transmitPermission(response.data.overrider_id);
                        this.request_sent = false;
                    } else if (!response.data.wait) {
                        this.is_waiting = false;
                        this.request_sent = false;
                        this.permissionError = 'Password was not accepted';
                    } else {
                        this.permissionTimeout = setTimeout(() => {
                            this.is_waiting = false;
                            this.request_sent = false;
                            this.permissionError = 'Timeout Exceeded';
                        }, 300000);
                    }
                });
            },
            toTitleCase(str) {
                return str.replace(
                    /\w\S*/g,
                    function(txt) {
                        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                    }
                );
            },
            permissionResponse(response) {
                if(response.id == this.$store.getters.getProfile.id && response.permissionName == this.permission) {
                    if(response.status == 'accepted') {
                        this.permissionOkFunction();
                        this.cancelPermission();
                        this.transmitPermission(response.overrider_id);
                        this.$bvToast.toast(this.toTitleCase(this.permission) + ' was accepted ', {
                            title: 'Permission Accepted',
                            variant: 'success',
                            autoHideDelay: 3000,
                        });
                    } else {
                        this.permissionError = 'Permission was Declined';
                        this.is_waiting = false;
                    }
                    clearTimeout(this.permissionTimeout);
                }
            },
            confirmPermission() {
                this.password =  '';
                this.userHasPermission = this.$store.getters.hasPermission(this.permission);
                if(!this.userHasPermission) {
                    this.isLoadingPermission = true;
                    this.$http.get('/users/' + this.$store.getters.getProfile.id + '/hasPermission?name='+encodeURIComponent(this.permission)).then((response) => {
                        if(response.data.hasPermission) {
                            this.userHasPermission = true;
                        }
                        else {
                            let data = response.data.users_with_permission;
                            this.users = [];
                            for(let i = 0; i < data.length; i++)
                            {
                                this.users[i] = {text: data[i].name, value: data[i].id};
                            }
                        }
                        this.isLoadingPermission = false;
                    });
                }
            },
            cancelPermission() {
                this.is_waiting = false;
                this.showPermission = false;
                this.selected_user = null;
                clearTimeout(this.permissionTimeout);
            },
            transmitPermission(id) {
                if(this.permissionEndpointWrap && this.permissionEndpointWrap.length) {
                    this.$store.commit(OVERRIDE, {endpoints: this.permissionEndpointWrap, id: id, permission: this.permission});
                }
            }
        },
        computed:{
            displayError:{
                get(){
                    return this.showErrorDialog;
                },
                set({title = 'Error Occured', text, ok='Ok', onClose = function(){} }){
                    this.showError = true;
                    this.errorText = text;
                    this.errorTitle = title;
                    this.errorOkText = ok;
                    this.errorClose = onClose;
                }
            },
            displayDialog:{
                get(){
                    return this.showQuestionDialog;
                },
                set({title = 'Error Occured', text, ok='Ok', okAction = function(){},cancel='Cancel', onClose = function(){} }){
                    this.showDialog= true;
                    this.dialogTitle = title;
                    this.dialogText = text;
                    this.dialogOkText = ok;

                    this.dialogCancelText =  cancel;
                    this.dialogOkFunction = okAction;
                    this.dialogClose = onClose;
                }
            },
            displayPermission:{
                get(){
                    return this.showPermissionDialog;
                },
                set({title = 'Permission Request', text, permission,ok='Manager Override', okAction = function(){},cancel='Cancel', onClose = function(){}, order_id = null, customer_id = null, endPointsLater = []}){
                    this.showPermission = true;
                    this.permissionTitle = title;
                    this.permissionText = text;
                    this.permissionOkText = ok;
                    this.permission = permission;

                    this.permissionCancelText =  cancel;
                    this.permissionOkFunction = okAction;
                    this.permissionClose = onClose;
                    this.confirmPermission();
                    this.permission_order_id = order_id || this.$store.getters.activeOrder ?this.$store.getters.activeOrder.id : null;
                    this.permission_customer_id = customer_id || this.$store.getters.activeOrder ? this.$store.getters.activeOrder.customer_id: null;
                    this.permissionError = null;
                    this.permissionEndpointWrap = endPointsLater;
                }
            },
            canPermissionAccept() {
                return this.userHasPermission || this.isLoadingPermission;
            },
        },
        watch:{
            'showError': function(){
                if(!this.showError){
                    this.errorClose();
                }
            },
            'showDialog': function(){
                if(!this.showDialog){
                    this.dialogClose();
                }
            },
            'showPermission': function() {
                if(!this.showPermission){
                    this.permissionClose();
                    this.cancelPermission();
                }
            },
            'PERMDEBUG': function(perm) {
                this.permissionResponse(perm);
            },
            selected_user() {
                this.password = null;
            }
        }
    };
</script>

<style>
.header_style h5{
    position: absolute;
    text-align: center;
    width: 90%;
    font-weight: bold;
}
</style>